"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _socket = require("./socket.constant");
var _notificationSound = _interopRequireDefault(require("../../../assets/notification-sound.mp3"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } // @flow
var list = JSON.parse(localStorage.getItem("notificationList"));
var listForRecord = JSON.parse(localStorage.getItem("notificationListForRecord"));
var notificationSound = localStorage.getItem("notificationSound");
var INIT_STATE = {
  notificationList: list ? list : [],
  notificationListForRecord: listForRecord ? listForRecord : [],
  loadingList: [],
  pdfResponse: null,
  notificationSound: notificationSound === "false" ? false : true,
  loadingListForRecord: [],
  successForRecord: null,
  errorForRecord: null,
  xlsxForRecord: null,
  xlsx: null,
  socketLoadingSteps: null
};
var playSound = function playSound(mute) {
  var audio = new Audio(_notificationSound.default);
  audio.play();
  audio.muted = !mute;
};
var checkIfValidationDispatchExist = function checkIfValidationDispatchExist(action) {
  try {
    var validationDispatch = sessionStorage.getItem("validationDispatch");
    if (validationDispatch) {
      var _action$payload;
      if (action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.data) {
        action.payload.data["validationDispatch"] = JSON.parse(validationDispatch);
      }
      sessionStorage.removeItem("validationDispatch");
    }
  } catch (error) {}
};
var socket = function socket() {
  var _action$payload2, _state$loadingListFor, _state$loadingList2, _state$notificationLi, _state$loadingListFor2, _state$notificationLi2, _state$loadingList3, _state$loadingList4, _state$loadingListFor3, _state$loadingListFor4, _state$loadingList5, _state$loadingListFor5;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _socket.actionTypes.SOCKET_RESPONSE:
      action.payload.data["unread"] = true;
      checkIfValidationDispatchExist(action);
      var notifyList = [action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.data].concat(_toConsumableArray(state.notificationList), _toConsumableArray(state.notificationListForRecord));
      localStorage.setItem("notificationList", JSON.stringify(notifyList));
      playSound(state.notificationSound);
      return _objectSpread(_objectSpread({}, state), {}, {
        error: false,
        success: true,
        notificationList: notifyList
      });
    case _socket.actionTypes.SOCKET_PDF:
      return _objectSpread(_objectSpread({}, state), {}, {
        pdfResponse: action.payload
      });
    case _socket.actionTypes.SOCKET_LOADING:
      var skipWebSocket = ["api/crm-field/mapping/test-fields"];
      var notShowSocket = skipWebSocket === null || skipWebSocket === void 0 ? void 0 : skipWebSocket.find(function (f) {
        var _action$payload3, _action$payload3$resp, _action$payload3$resp2;
        return (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : (_action$payload3$resp = _action$payload3.responseStep) === null || _action$payload3$resp === void 0 ? void 0 : (_action$payload3$resp2 = _action$payload3$resp.config) === null || _action$payload3$resp2 === void 0 ? void 0 : _action$payload3$resp2.url.includes(f);
      });
      if (notShowSocket) {
        var _action$payload4;
        return _objectSpread(_objectSpread({}, state), {}, {
          socketLoadingSteps: action === null || action === void 0 ? void 0 : (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.steps
        });
      } else {
        var _state$loadingList;
        var isExist = false;
        (_state$loadingList = state.loadingList) === null || _state$loadingList === void 0 ? void 0 : _state$loadingList.forEach(function (loading) {
          var _action$payload5;
          if (loading.id == (action === null || action === void 0 ? void 0 : (_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.id)) {
            var _action$payload6, _action$payload6$prog, _action$payload7, _action$payload7$prog;
            isExist = true;
            loading.progress.percent = (action === null || action === void 0 ? void 0 : (_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : (_action$payload6$prog = _action$payload6.progress) === null || _action$payload6$prog === void 0 ? void 0 : _action$payload6$prog.total) === 0 ? 100 : action === null || action === void 0 ? void 0 : (_action$payload7 = action.payload) === null || _action$payload7 === void 0 ? void 0 : (_action$payload7$prog = _action$payload7.progress) === null || _action$payload7$prog === void 0 ? void 0 : _action$payload7$prog.percent;
            loading.time = action.payload.time;
            loading.steps = action.payload.steps;
          }
        });
        if (!isExist) {
          action.payload.unread = true;
          state.loadingList = [action === null || action === void 0 ? void 0 : action.payload].concat(_toConsumableArray(state.loadingList));
        }
        localStorage.setItem("loadingList", JSON.stringify(state.loadingList));
        return _objectSpread({}, state);
      }
    case _socket.actionTypes.SOCKET_LOADING_RECORD:
      var isExistForRecord = false;
      (_state$loadingListFor = state.loadingListForRecord) === null || _state$loadingListFor === void 0 ? void 0 : _state$loadingListFor.forEach(function (loading) {
        var _action$payload8;
        if (loading.id == (action === null || action === void 0 ? void 0 : (_action$payload8 = action.payload) === null || _action$payload8 === void 0 ? void 0 : _action$payload8.id)) {
          var _action$payload9, _action$payload9$prog, _action$payload10, _action$payload10$pro;
          isExistForRecord = true;
          loading.progress.percent = (action === null || action === void 0 ? void 0 : (_action$payload9 = action.payload) === null || _action$payload9 === void 0 ? void 0 : (_action$payload9$prog = _action$payload9.progress) === null || _action$payload9$prog === void 0 ? void 0 : _action$payload9$prog.total) === 0 ? 100 : action === null || action === void 0 ? void 0 : (_action$payload10 = action.payload) === null || _action$payload10 === void 0 ? void 0 : (_action$payload10$pro = _action$payload10.progress) === null || _action$payload10$pro === void 0 ? void 0 : _action$payload10$pro.percent;
          loading.time = action.payload.time;
          loading.steps = action.payload.steps;
        }
      });
      if (!isExistForRecord) {
        action.payload.unread = true;
        state.loadingListForRecord = [action === null || action === void 0 ? void 0 : action.payload].concat(_toConsumableArray(state.loadingListForRecord));
      }
      localStorage.setItem("loadingListForRecord", JSON.stringify(state.loadingListForRecord));
      return _objectSpread({}, state);
    case _socket.actionTypes.READ:
      state === null || state === void 0 ? void 0 : (_state$loadingList2 = state.loadingList) === null || _state$loadingList2 === void 0 ? void 0 : _state$loadingList2.forEach(function (loading) {
        loading.unread = false;
      });
      state === null || state === void 0 ? void 0 : (_state$notificationLi = state.notificationList) === null || _state$notificationLi === void 0 ? void 0 : _state$notificationLi.forEach(function (notification) {
        notification.unread = false;
      });
      state === null || state === void 0 ? void 0 : (_state$loadingListFor2 = state.loadingListForRecord) === null || _state$loadingListFor2 === void 0 ? void 0 : _state$loadingListFor2.forEach(function (loading) {
        loading.unread = false;
      });
      state === null || state === void 0 ? void 0 : (_state$notificationLi2 = state.notificationListForRecord) === null || _state$notificationLi2 === void 0 ? void 0 : _state$notificationLi2.forEach(function (notification) {
        notification.unread = false;
      });
      var x = [].concat(_toConsumableArray(state === null || state === void 0 ? void 0 : state.notificationList), _toConsumableArray(state === null || state === void 0 ? void 0 : state.notificationListForRecord));
      localStorage.setItem("notificationList", JSON.stringify(x));
      return _objectSpread({}, state);
    case _socket.actionTypes.MINIMIZE:
      (_state$loadingList3 = state.loadingList) === null || _state$loadingList3 === void 0 ? void 0 : _state$loadingList3.forEach(function (item, index) {
        if (item.id === action.payload) {
          state.loadingList[index].isHide = true;
        }
      });
      (_state$loadingList4 = state.loadingList) === null || _state$loadingList4 === void 0 ? void 0 : _state$loadingList4.filter(function (loading) {
        return loading.progress.percent !== 100;
      });
      (_state$loadingListFor3 = state.loadingListForRecord) === null || _state$loadingListFor3 === void 0 ? void 0 : _state$loadingListFor3.forEach(function (item, index) {
        if (item.id === action.payload) {
          state.loadingListForRecord[index].isHide = true;
        }
      });
      (_state$loadingListFor4 = state.loadingListForRecord) === null || _state$loadingListFor4 === void 0 ? void 0 : _state$loadingListFor4.filter(function (loading) {
        return loading.progress.percent !== 100;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        success: false,
        error: false,
        successForRecord: false,
        errorForRecord: false
      });
    case _socket.actionTypes.MUTE_UNMUTE:
      localStorage.setItem("notificationSound", !state.notificationSound);
      return _objectSpread(_objectSpread({}, state), {}, {
        notificationSound: !state.notificationSound
      });
    case _socket.actionTypes.NOTIFICATION_DELETE:
      var notificationList = [].concat(_toConsumableArray(state.notificationList), _toConsumableArray(state === null || state === void 0 ? void 0 : state.notificationListForRecord));
      if (action.payload === "all") {
        notificationList = [];
      } else {
        notificationList.splice(action.payload, 1);
      }
      localStorage.setItem("notificationList", JSON.stringify(notificationList));
      return _objectSpread(_objectSpread({}, state), {}, {
        notificationList: notificationList
      });
    case _socket.actionTypes.XLSX:
      return _objectSpread(_objectSpread({}, state), {}, {
        xlsx: action.payload
      });
    case _socket.actionTypes.RESET:
      var _list = (_state$loadingList5 = state.loadingList) === null || _state$loadingList5 === void 0 ? void 0 : _state$loadingList5.filter(function (loading) {
        return loading.progress.percent !== 100;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        pdfResponse: null,
        xlsx: null,
        success: false,
        error: false,
        loadingList: _list
      });
    case _socket.actionTypes.SOCKET_RESET_RECORD:
      var _listForRecord = (_state$loadingListFor5 = state.loadingListForRecord) === null || _state$loadingListFor5 === void 0 ? void 0 : _state$loadingListFor5.filter(function (loading) {
        return loading.progress.percent !== 100;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        xlsx: null,
        successForRecord: false,
        errorForRecord: false,
        loadingListForRecord: _listForRecord
      });
    default:
      return _objectSpread({}, state);
  }
};
var _default = socket;
exports.default = _default;